import {createQuery} from 'react-query-kit'

import {apiGetRecaps} from '../api/scribe/api-get-recaps'
import type {Recap, RecapsRequest} from '../api/scribe/types'

export const useRecapsQuery = createQuery<Array<Recap>, RecapsRequest>({
  queryKey: ['memex', 'recaps'],
  fetcher: (variables: RecapsRequest) => {
    return apiGetRecaps(variables)
  },
})
